<template>
	<a
		class="btn btn-primary"
		:href="qetAQuoteUrl"
		target="_blank"
	>Get a Quote</a>
</template>


<style lang="scss">

</style>


<script setup>
import { computed } from 'vue'


const props = defineProps({
	colorData: {
		type: Array,
		required: true,
	},
})


const qetAQuoteUrl = computed( () => {
	const url = new URL( window.webfx.colorMixer.addonData.urls.get_a_quote )

	let dataForLink = props.colorData.map( color => ({
		c: color.code,
		p: color.percentage,
	}) )

	dataForLink = window.btoa( JSON.stringify( dataForLink ) )

	url.searchParams.set( 'color_data', dataForLink )

	return url.toString()
})

</script>
